import React, { FC } from 'react';
import { useIconColor } from '../../../hooks/useIconColor';

interface IconStarProps {
  className?: string;
  color?: string;
}

const IconStar: FC<IconStarProps> = (props: IconStarProps) => {
  const { className, color } = props;

  const { iconColor } = useIconColor();
  const fillColor = color || iconColor;

  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4951 11.2463L16.3148 3L12.1345 11.2463L3 12.6738L9.55088 19.1977L8.0858 28.3262L16.3148 24.112L24.5438 28.3262L23.0787 19.1977L29.6296 12.6738L20.4951 11.2463Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default IconStar;
